import React, { useEffect, useRef, useState } from 'react';
import { ToastContainer, Slide, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as XLSX from 'xlsx';
import { useLocation, useNavigate } from 'react-router-dom';
import { logout } from '../utils/auth';
import {
  FaRegStar,
  FaCheck,
  FaBullhorn,
  FaGift,
  FaUtensils,
  FaPaintBrush,
} from 'react-icons/fa';
import {
  getAppType,
  getAudienceOptions,
  getAudienceStyle,
  exportToExcel,
} from '../utils/appConstants';
import { FaChartPie } from 'react-icons/fa6';
import { LuLoader } from 'react-icons/lu';
import axios from 'axios';
import '../styles/smart-incentives.css';
const SmartIncentives = () => {
  // track the Audience dropdown container
  const audienceWrapperRef = useRef(null);
  const [showDropdown, setShowDropdown] = useState(false);
  const [selectedAudiences, setSelectedAudiences] = useState([]);
  const [showAudienceDropdown, setShowAudienceDropdown] = useState(false);
  const [isEveryone, setIsEveryone] = useState(false);

  // track the Trigger dropdown container
  const triggerWrapperRef = useRef(null);
  const [selectedTrigger, setSelectedTrigger] = useState('');
  const [showTriggerDropdown, setShowTriggerDropdown] = useState(false);

  // ── TRIGGER SETTINGS state ─────────────────────────────────────────────
  const [selectedIncentive, setSelectedIncentive] = useState(''); // Point Bonus
  const [deliveryMethod, setDeliveryMethod] = useState('Scratch & Win');
  const [triggerBy, setTriggerBy] = useState('turnover');
  const [triggerValue, setTriggerValue] = useState('');
  const [promotionName, setPromotionName] = useState('');
  const [timePeriod, setTimePeriod] = useState('');
  const [scheduleStart, setScheduleStart] = useState('');
  const [scheduleEnd, setScheduleEnd] = useState('');
  const [tempBenefits, setTempBenefits] = useState('');
  const [levelUpDays, setLevelUpDays] = useState(1);
  const [expiresOn, setExpiresOn] = useState('');
  // ────────────────────────────────────────────────────────────────────────

  const [campaignData, setCampaignData] = useState([]);
  const [expiredData, setExpiredData] = useState([]);

  const [campaignPage, setCampaignPage] = useState(1);
  const [campaignTotalPages, setCampaignTotalPages] = useState(1);
  const [expiredPage, setExpiredPage] = useState(1);
  const [expiredTotalPages, setExpiredTotalPages] = useState(1);
  const [limit, setLimit] = useState(10);

  const [budget, setBudget] = useState('');
  const [unlimitedBudget, setUnlimitedBudget] = useState(true);
  const [publishing, setPublishing] = useState(false);

  const access = localStorage.getItem('access');
  const userType = localStorage.getItem('userType');

  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  const token = localStorage.getItem('token');
  const [selectedVenue, setSelectedVenue] = useState(
    localStorage.getItem('selectedVenue') || ''
  );
  const appGroup = localStorage.getItem('appGroup');
  const [loading, setLoading] = useState(true);
  const [venues, setVenues] = useState([]);

  const UPLOAD_TARGETED_LIST = 'upload-targeted-list';
  const [isUploadTargetedList, setIsUploadTargetedList] = useState(false);
  const [targetedListFile, setTargetedListFile] = useState(null);
  const [targetedListRows, setTargetedListRows] = useState([]);
  const [targetedListStep, setTargetedListStep] = useState('upload');
  const targetedListInputRef = useRef(null);

  const [processingCsvIncentiveId, setProcessingCsvIncentiveId] =
    useState(null);

  const [activeTab, setActiveTab] = useState('createIncentive'); // 'createIncentive' or 'activeCampaigns'

  const location = useLocation();
  const navigate = useNavigate();

  const email = localStorage.getItem('userEmail');
  const userInitial = email ? email.charAt(0).toUpperCase() : '';

  const resetForm = () => {
    setSelectedIncentive('');
    setDeliveryMethod('Scratch & Win');
    setSelectedAudiences([]);
    setIsEveryone(false);

    setSelectedTrigger('');
    setTriggerValue('');
    setTimePeriod('');

    setTempBenefits('');

    setBudget('');
    setUnlimitedBudget(true);

    setScheduleStart('');
    setScheduleEnd('');

    setShowAudienceDropdown(false);
    setShowTriggerDropdown(false);

    setIsUploadTargetedList(false);
    setTargetedListFile(null);
    setTargetedListRows([]);
    setTargetedListStep('upload');
  };

  const isActive = (path) => {
    return location.pathname === path;
  };

  // Fix for sidebar navigation - ensure we have the state when navigating
  const handleNavigation = (path) => {
    navigate(path);
  };

  const getTTPValue = (tp) => {
    switch (tp) {
      // ['daily', 'last 7 days', 'last 14 days', 'last 30 days']
      case 'daily':
        return 'Daily';
      case 'last 7 days':
        return 'Last7Days';
      case 'last 14 days':
        return 'Last14Days';
      case 'last 30 days':
        return 'Last30Days';
      default:
        return tp;
    }
  };

  useEffect(() => {
    const wrapperEl = audienceWrapperRef.current;

    const handleClickOutside = (e) => {
      // if open and click occurred outside *this* wrapper, close it
      if (showAudienceDropdown && wrapperEl && !wrapperEl.contains(e.target)) {
        setShowAudienceDropdown(false);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [showAudienceDropdown]);

  useEffect(() => {
    const wrapperEl = triggerWrapperRef.current;

    const handleClickOutside = (e) => {
      // if open and click occurred outside *this* wrapper, close it
      if (showTriggerDropdown && wrapperEl && !wrapperEl.contains(e.target)) {
        setShowTriggerDropdown(false);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [showTriggerDropdown]);

  const toggleAudienceDropdown = (e) => {
    e.stopPropagation(); // Prevent event from bubbling up
    setShowTriggerDropdown(false);

    setShowAudienceDropdown((open) => !open);
  };

  const toggleTriggerDropdown = (e) => {
    e.stopPropagation(); // Prevent event from bubbling up
    console.log(
      'toggleTriggerDropdown called, current state:',
      showTriggerDropdown
    );
    setShowAudienceDropdown(false); // Close audience dropdown if open
    setShowTriggerDropdown((open) => {
      console.log('Setting showTriggerDropdown to:', !open);
      return !open;
    });
  };

  const handleAudienceChange = (value) => {
    if (value === UPLOAD_TARGETED_LIST) {
      setIsUploadTargetedList(true);
      setIsEveryone(false);
      setSelectedAudiences([]);
      setShowAudienceDropdown(false);
      setTargetedListFile(null);
      setTargetedListRows([]);
      setTargetedListStep('upload');
      return;
    }

    setIsUploadTargetedList(false);
    setTargetedListFile(null);
    setTargetedListRows([]);
    setTargetedListStep('upload');
    // normal multi‑select toggle
    setSelectedAudiences((prev) =>
      prev.includes(value) ? prev.filter((v) => v !== value) : [...prev, value]
    );
    setIsEveryone(false);
  };

  const handleTriggerChange = (value) => {
    setSelectedTrigger(value);
    setShowTriggerDropdown(false);
  };

  let audienceOptions = [];

  audienceOptions = getAudienceOptions(selectedVenue);

  useEffect(() => {
    if (selectedIncentive === 'Point Bonus') {
      setIsEveryone(true);
      setSelectedAudiences(audienceOptions.map((option) => option.value));
    }
  }, [selectedIncentive]);

  const handleEveryoneChange = (e) => {
    const checked = e.target.checked;
    setIsEveryone(checked);

    if (checked) {
      setIsUploadTargetedList(false);
      setTargetedListFile(null);
      setTargetedListRows([]);
      setTargetedListStep('upload');
      // Select all audience options when "Everyone" is checked
      setSelectedAudiences(audienceOptions.map((option) => option.value));
    } else {
      // Clear selection when "Everyone" is unchecked
      setSelectedAudiences([]);
    }
  };

  let triggerOptions = [
    { value: 'Turnover', label: 'Turnover' },
    { value: 'Revenue', label: 'Revenue' },
    { value: 'Visits', label: 'Visits' },
    { value: 'BeverageSales', label: 'Beverage Sales' },
    { value: 'FoodSales', label: 'Food Sales' },
  ];

  useEffect(() => {
    const fetchVenues = async () => {
      try {
        const response = await axios.get(`${baseUrl}/admin/app-registries`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        if (response.data && response.data.data) {
          setVenues(response.data.data);
          setLoading(false);
        }
      } catch (error) {
        console.error('Error fetching venues:', error);
        setLoading(false);
      }
    };

    if (token && userType === 'admin') {
      fetchVenues();
    }
  }, [token]);

  const handlePublishIncentive = async () => {
    try {
      if (!selectedIncentive) {
        toast.error('Please select a smart incentive');
        return;
      }

      // targeted-list flow uses the CSV API.
      const isTargetedList =
        isUploadTargetedList && targetedListStep === 'target';

      /*
       * ------------------------------------------------------------
       * Targeted List
       * POST /smart-incentive/csv
       * ------------------------------------------------------------
       */
      if (isTargetedList) {
        if (!targetedListFile) {
          toast.error('Please select a target file');
          return;
        }

        if (!tempBenefits) {
          toast.error('Please enter incentive value');
          return;
        }

        if (!unlimitedBudget && !budget) {
          toast.error('Please enter budget');
          return;
        }

        if (!scheduleStart || !scheduleEnd) {
          toast.error('Please select start and end dates');
          return;
        }

        setPublishing(true);

        const formData = new FormData();

        formData.append('audienceFile', targetedListFile);
        formData.append('offerType', selectedIncentive);
        formData.append(
          'deliveryMethod',
          selectedIncentive === 'Kiosk' ? 'Kiosk' : 'Scratch & Win'
        );
        formData.append('incentiveValue', String(Number(tempBenefits)));
        formData.append('unlimitedBudget', String(unlimitedBudget));
        formData.append('startDate', scheduleStart);
        formData.append('endDate', scheduleEnd);

        // API expects budget as a form-data field.
        // When unlimitedBudget is true, send 0 just like the normal API payload.
        formData.append(
          'budget',
          unlimitedBudget ? '0' : String(Number(budget))
        );

        const response = await axios.post(
          'https://betaapi.s2w.com.au/smart-incentive/csv',
          formData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        console.log('CSV incentive response:', response.data);

        toast.success(
          response?.data?.message || 'Smart incentive created successfully'
        );

        const createdIncentiveId = response?.data?.data?._id;

        setActiveTab('activeCampaigns');

        if (createdIncentiveId) {
          setProcessingCsvIncentiveId(createdIncentiveId);

          const maxAttempts = 30;
          const pollInterval = 2000;

          for (let attempt = 0; attempt < maxAttempts; attempt++) {
            await new Promise((resolve) => setTimeout(resolve, pollInterval));

            try {
              const pollResponse = await axios.get(
                `${baseUrl}/smart-incentive/all?page=${campaignPage}&limit=${limit}`,
                {
                  headers: {
                    Authorization: `Bearer ${token}`,
                  },
                }
              );

              if (pollResponse.data && pollResponse.data.data) {
                const updatedIncentive = pollResponse.data.data.find(
                  (incentive) => incentive._id === createdIncentiveId
                );

                if (updatedIncentive) {
                  console.log('CSV incentive processing status:', {
                    status: updatedIncentive.processingStatus,
                    csvProcessedUsers: updatedIncentive.csvProcessedUsers,
                  });

                  setCampaignData((prevData) =>
                    prevData.map((incentive) =>
                      incentive._id === createdIncentiveId
                        ? {
                            ...incentive,
                            ...updatedIncentive,
                          }
                        : incentive
                    )
                  );

                  if (updatedIncentive.processingStatus === 'completed') {
                    break;
                  }
                }
              }
            } catch (pollError) {
              console.error('Error polling CSV incentive:', pollError);
            }
          }

          setProcessingCsvIncentiveId(null);
        }

        setActiveTab('activeCampaigns');
        return;
      }

      /*
       * ------------------------------------------------------------
       * Existing flow
       * POST /smart-incentive/create
       * ------------------------------------------------------------
       */

      if (!timePeriod) {
        toast.error('Please select trigger time period');
        return;
      }

      if (!isEveryone && selectedAudiences.length === 0) {
        toast.error('Please select at least one audience');
        return;
      }

      if (!selectedTrigger) {
        toast.error('Please select a trigger type');
        return;
      }

      if (!triggerValue) {
        toast.error('Please enter trigger value');
        return;
      }

      if (!tempBenefits) {
        toast.error('Please enter incentive value');
        return;
      }

      if (!unlimitedBudget && !budget) {
        toast.error('Please enter budget');
        return;
      }

      if (!scheduleStart || !scheduleEnd) {
        toast.error('Please select start and end dates');
        return;
      }

      setPublishing(true);

      const payload = {
        offerType: selectedIncentive,
        deliveryMethod:
          selectedIncentive === 'Kiosk' ? 'Kiosk' : 'Scratch & Win',
        ...(selectedIncentive === 'Kiosk' && { promotionName }),
        audience: isEveryone ? ['everyone'] : selectedAudiences,
        triggerType: selectedTrigger,
        timePeriod: getTTPValue(timePeriod),
        triggerValue: Number(triggerValue),
        incentiveValue: Number(tempBenefits),
        budget: unlimitedBudget ? 0 : Number(budget),
        unlimitedBudget,
        startDate: scheduleStart,
        endDate: scheduleEnd,
      };

      await axios.post(
        'https://betaapi.s2w.com.au/smart-incentive/create',
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );

      toast.success('Smart incentive created successfully');
      setActiveTab('activeCampaigns');
    } catch (error) {
      console.error(error);

      toast.error(
        error?.response?.data?.message || 'Failed to create smart incentive'
      );
    } finally {
      setPublishing(false);
    }
  };

  const fetchCampaignData = async () => {
    if (activeTab !== 'activeCampaigns') return; // Only fetch when Active Campaigns tab is selected
    setLoading(true);
    try {
      const response = await axios.get(
        `${baseUrl}/smart-incentive/all?page=${campaignPage}&limit=${limit}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.data && response.data.data) {
        setCampaignData(response.data.data);
        setCampaignTotalPages(response.data.pagination.totalPages);
        setLoading(false);
      }
    } catch (err) {
      console.error('Error fetching campaign data:', err);
      toast.error('Failed to fetch campaign data');
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCampaignData();
  }, [token, activeTab, campaignPage, limit]);

  useEffect(() => {
    const fetchExpiredData = async () => {
      if (activeTab !== 'expiredIncentives') return; // Only fetch when Expired Incentives tab is selected
      setLoading(true);

      try {
        const response = await axios.get(
          `${baseUrl}/smart-incentive/inactive-expired?page=${expiredPage}&limit=${limit}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response.data && response.data.data) {
          setExpiredData(response.data.data);
          setExpiredTotalPages(response.data.pagination.totalPages);
          setLoading(false);
        }
      } catch (err) {
        console.error('Error fetching campaign data:', err);
        toast.error('Failed to fetch campaign data');
        setLoading(false);
      }
    };

    fetchExpiredData();
  }, [token, activeTab, expiredPage, limit]);

  const handleDeactivateIncentive = async (id) => {
    try {
      await axios.patch(
        `${baseUrl}/smart-incentive/inactive`,
        { incentiveId: id },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );
      toast.success('Incentive deactivated successfully');

      // Refresh the active campaigns list after deactivation
      await fetchCampaignData();
    } catch (err) {
      console.error('Error deactivating incentive:', err);
      toast.error('Failed to deactivate incentive');
    }
  };

  const formatDateWithOffset = (dateString) => {
    if (!dateString) return '-';

    const date = new Date(dateString);

    // add 10 hours
    date.setTime(date.getTime() + 10 * 60 * 60 * 1000);

    const day = String(date.getUTCDate()).padStart(2, '0');
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const year = date.getUTCFullYear();

    return `${day}-${month}-${year}`;
  };

  useEffect(() => {
    if (activeTab === 'createIncentive') {
      resetForm();
    }
  }, [activeTab]);

  const pointsDollarValue =
    tempBenefits && !isNaN(tempBenefits)
      ? (Number(tempBenefits) / 100).toFixed(2)
      : '0.00';

  const budgetDollarValue =
    budget && !isNaN(budget) ? (Number(budget) / 100).toFixed(2) : '0.00';

  const currentPage =
    activeTab === 'activeCampaigns' ? campaignPage : expiredPage;
  const currentTotalPages =
    activeTab === 'activeCampaigns' ? campaignTotalPages : expiredTotalPages;

  // Pagination controls per tab
  const onPrev = () => {
    if (activeTab === 'activeCampaigns') {
      if (campaignPage > 1) setCampaignPage((p) => p - 1);
    } else if (activeTab === 'expiredIncentives') {
      if (expiredPage > 1) setExpiredPage((p) => p - 1);
    }
  };
  const onNext = () => {
    if (activeTab === 'activeCampaigns') {
      if (campaignPage < campaignTotalPages) setCampaignPage((p) => p + 1);
    } else if (activeTab === 'expiredIncentives') {
      if (expiredPage < expiredTotalPages) setExpiredPage((p) => p + 1);
    }
  };

  const tableData =
    activeTab === 'activeCampaigns' ? campaignData : expiredData;

  const formatTriggerType = (type) => {
    switch (type) {
      case 'FoodSales':
        return 'Food Sales';
      case 'BeverageSales':
        return 'Beverage Sales';
      default:
        return type;
    }
  };

  const formatTimePeriod = (type) => {
    switch (type) {
      case 'Last7Days':
        return 'Last 7 Days';
      case 'Last14Days':
        return 'Last 14 Days';
      case 'Last30Days':
        return 'Last 30 Days';
      default:
        return type;
    }
  };

  const handleExportApplicableUsers = async (incentiveId) => {
    try {
      setLoading(true);

      // Find the incentive in the currently displayed table data
      const incentive = tableData.find((item) => item._id === incentiveId);

      // Add audienceMode only when it exists in tableData
      const audienceModeParam =
        incentive?.audienceMode === 'csv'
          ? `&audienceMode=${encodeURIComponent(incentive.audienceMode)}`
          : '';

      // First page
      const firstResponse = await axios.get(
        `https://betaapi.s2w.com.au/smart-incentive/applicable-users/${incentiveId}?page=1&limit=100${audienceModeParam}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const totalPages = firstResponse.data.pagination.totalPages;

      let allUsers = [...firstResponse.data.data];

      // Fetch remaining pages
      const requests = [];

      for (let page = 2; page <= totalPages; page++) {
        requests.push(
          axios.get(
            `https://betaapi.s2w.com.au/smart-incentive/applicable-users/${incentiveId}?page=${page}&limit=100${audienceModeParam}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          )
        );
      }

      const responses = await Promise.all(requests);

      responses.forEach((res) => {
        allUsers.push(...res.data.data);
      });

      // Format for excel
      const excelData = allUsers.map((user) => ({
        Id: user.Id,
        'Bluize ID': user.BluizeId,
        'Card Number': user.CardNumber,
        'First Name': user.GivenNames,
        'Last Name': user.Surname,
        Email: user.Email,
        Mobile: user.Mobile,
        Address: user.Address,
        Suburb: user.Suburb,
        State: user.State,
        'Post Code': user.PostCode,
        Gender: user.Gender,
      }));

      exportToExcel(
        excelData,
        'Applicable Members',
        `ApplicableMembers_${incentiveId}.xlsx`
      );

      toast.success('Members exported successfully');
    } catch (err) {
      console.error(err);
      toast.error('Failed to export members');
    } finally {
      setLoading(false);
    }
  };

  const handleExportRedeemedUsers = async (incentiveId) => {
    try {
      setLoading(true);

      const firstResponse = await axios.get(
        `https://betaapi.s2w.com.au/smart-incentive/collected-users/${incentiveId}?page=1&limit=100`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const totalPages = firstResponse.data.pagination.totalPages;

      let allUsers = [...firstResponse.data.data];

      const requests = [];

      for (let page = 2; page <= totalPages; page++) {
        requests.push(
          axios.get(
            `https://betaapi.s2w.com.au/smart-incentive/collected-users/${incentiveId}?page=${page}&limit=100`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          )
        );
      }

      const responses = await Promise.all(requests);

      responses.forEach((res) => {
        allUsers.push(...res.data.data);
      });

      const excelData = allUsers.map((user) => ({
        'Redeemed Date': user?.issuedDateBrisbane ?? '',
        'Incentive Value': user?.incentiveValue ?? '',
        Id: user?.Id ?? '',
        'Bluize Id': user?.BluizeId ?? '',
        'Card Number': user?.CardNumber ?? '',
        'Given Name': user?.GivenNames ?? '',
        Surname: user?.Surname ?? '',
        Email: user?.Email ?? '',
        Mobile: user?.Mobile ?? '',
        Address: user?.Address ?? '',
        'Post Code': user?.PostCode ?? '',
        Suburb: user?.Suburb ?? '',
        State: user?.State ?? '',
        Gender: user?.Gender ?? '',
      }));

      exportToExcel(
        excelData,
        'Redeemed Members',
        `RedeemedMembers_${incentiveId}.xlsx`
      );

      toast.success('Members exported successfully');
    } catch (err) {
      console.error(err);
      toast.error('Failed to export members');
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="digital-app-container" style={{ height: '1100px' }}>
      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        transition={Slide}
        style={{
          zIndex: 9999,
          marginTop: '90px',
          fontSize: '14px',
          minWidth: '300px',
          textAlign: 'center',
        }}
      />
      <header className="app-header">
        <div
          className="s2w-logo"
          onClick={() => handleNavigation('/dashboard')}
        >
          <img src="/s2w-logo.png" alt="S2W Logo" />
        </div>
        <div className="header-buttons">
          {userType === 'admin' ? (
            <>
              <button
                className="digital-app-btn"
                onClick={() => handleNavigation('/digital-app')}
              >
                Digital App
              </button>
              <button
                className="market-to-members-btn"
                onClick={() => handleNavigation('/market-to-members')}
              >
                Market to Members
              </button>
              {/* <button
                className="displays-btn"
                onClick={() => handleNavigation('/displays')}
              >
                Displays
              </button> */}
            </>
          ) : (
            <>
              {access.includes('digital') && (
                <button
                  className="digital-app-btn"
                  onClick={() => handleNavigation('/digital-app')}
                >
                  Digital App
                </button>
              )}
              {access.includes('m2m') && (
                <button
                  className="market-to-members-btn"
                  onClick={() => handleNavigation('/market-to-members')}
                >
                  Market to Members
                </button>
              )}
              {/* {access.includes('displays') && (
                <button
                  className="displays-btn"
                  onClick={() => handleNavigation('/displays')}
                >
                  Displays
                </button>
              )} */}
            </>
          )}

          {userType === 'admin' && (
            <div
              style={{
                position: 'absolute',
                right: '70px',
                top: '40px',
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
              }}
            >
              <span
                style={{
                  fontWeight: '500',
                  color: '#002977',
                  fontSize: '15px',
                  fontWeight: 'bold',
                }}
              >
                Venue
              </span>
              <select
                style={{
                  padding: '5px 10px',
                  borderRadius: '4px',
                  border: '1px solid #ccc',
                  backgroundColor: '#F2F2F2',
                  cursor: 'pointer',
                  minWidth: '200px',
                }}
                value={selectedVenue}
                onChange={async (e) => {
                  const selectedValue = e.target.value;
                  if (!selectedValue) return;

                  try {
                    const response = await axios.post(
                      `${baseUrl}/admin/token`,
                      { appType: selectedValue },
                      {
                        headers: {
                          Authorization: `Bearer ${token}`,
                          'Content-Type': 'application/json',
                        },
                      }
                    );

                    if (
                      response.data &&
                      response.data.data &&
                      response.data.data.token
                    ) {
                      // Remove old token and save new one
                      localStorage.removeItem('token');
                      localStorage.setItem('token', response.data.data.token);
                      setSelectedVenue(selectedValue);
                      localStorage.removeItem('selectedVenue');
                      localStorage.setItem('selectedVenue', selectedValue);

                      navigate('/dashboard');
                    }
                  } catch (error) {
                    console.error('Error updating venue:', error);
                  }
                }}
                disabled={loading}
              >
                {userType === 'admin' &&
                  venues.map(
                    (venue) =>
                      venue.appType === appGroup &&
                      venue.appName &&
                      venue.appName.map((app, index) => (
                        <option key={`${venue._id}-${index}`} value={app}>
                          {getAppType(app)}
                        </option>
                      ))
                  )}
                {userType === 'user' && (
                  <option value={appGroup}>{getAppType(appGroup)}</option>
                )}
              </select>
            </div>
          )}
        </div>
        <div className="user-section">
          <div
            className="user-avatar"
            onClick={() => setShowDropdown(!showDropdown)}
          >
            {userInitial}
          </div>
          {showDropdown && (
            <div className="dropdown-menu">
              <p>{email}</p>
              <button className="logout-btn" onClick={() => logout(navigate)}>
                Logout
              </button>
            </div>
          )}
        </div>
      </header>

      <aside className="sidebar">
        <button
          className={`sidebar-btn ${isActive('/digital-app') ? 'active' : ''}`}
          onClick={() => handleNavigation('/digital-app')}
        >
          <FaBullhorn
            className={`sidebar-icon ${
              isActive('/digital-app') ? '' : 'navy-icon'
            }`}
          />
          Promotions
        </button>
        <button
          className={`sidebar-btn ${
            isActive('/special-offers') ? 'active' : ''
          }`}
          onClick={() => handleNavigation('/special-offers')}
        >
          <FaGift
            className={`sidebar-icon ${
              isActive('/special-offers') ? '' : 'navy-icon'
            }`}
          />
          Special Offers
        </button>
        <button
          className={`sidebar-btn ${
            isActive('/smart-incentives') ? 'active' : ''
          }`}
          onClick={() => handleNavigation('/smart-incentives')}
        >
          <FaRegStar
            className={`sidebar-icon ${
              isActive('/smart-incentives') ? '' : 'navy-icon'
            }`}
          />
          Smart Incentives
        </button>
        <button
          className={`sidebar-btn ${isActive('/my-benefits') ? 'active' : ''}`}
          onClick={() => handleNavigation('/my-benefits')}
        >
          <FaUtensils
            className={`sidebar-icon ${
              isActive('/my-benefits') ? '' : 'navy-icon'
            }`}
          />
          My Benefits
        </button>

        <button
          className={`sidebar-btn ${isActive('/art-gallery') ? 'active' : ''}`}
          onClick={() => handleNavigation('/art-gallery')}
        >
          <FaPaintBrush
            className={`sidebar-icon ${
              isActive('/art-gallery') ? '' : 'navy-icon'
            }`}
          />
          Art Gallery
        </button>

        <button
          className={`sidebar-btn ${isActive('/reporting') ? 'active' : ''}`}
          onClick={() => navigate('/reporting')}
        >
          <FaChartPie
            className={`sidebar-icon ${
              isActive('/reporting') ? '' : 'navy-icon'
            }`}
          />
          Reporting
        </button>
      </aside>

      <div className="sa-filter-buttons" style={{ zIndex: 1000, left: '16%' }}>
        <button
          className={`user-btn ${
            activeTab === 'createIncentive' ? 'active' : ''
          }`}
          onClick={() => setActiveTab('createIncentive')}
        >
          Create Incentive
        </button>
        <button
          className={`user-btn ${
            activeTab === 'activeCampaigns' ? 'active' : ''
          }`}
          onClick={() => setActiveTab('activeCampaigns')}
        >
          Active Campaigns
        </button>
        <button
          className={`user-btn ${
            activeTab === 'expiredIncentives' ? 'active' : ''
          }`}
          onClick={() => setActiveTab('expiredIncentives')}
        >
          Expired Incentives
        </button>
      </div>

      {activeTab === 'createIncentive' ? (
        <div className="content-body">
          <div className="content-wrapper-displays">
            <section className="current-posts-display">
              <h2>Choose Smart Incentive</h2>
              <div className="incentive-options">
                <label className="incentive-option">
                  <input
                    type="radio"
                    name="incentive"
                    value="Point Bonus"
                    checked={selectedIncentive === 'Point Bonus'}
                    onChange={(e) => setSelectedIncentive(e.target.value)}
                    className="incentive-radio"
                    style={{ accentColor: '#002977' }}
                  />
                  <div className="incentive-image">
                    <img src="/points_bonus.png" alt="Points Bonus" />
                  </div>
                </label>
                <label className="incentive-option">
                  <input
                    type="radio"
                    name="incentive"
                    value="Kiosk"
                    checked={selectedIncentive === 'Kiosk'}
                    onChange={(e) => setSelectedIncentive(e.target.value)}
                    className="incentive-radio"
                    style={{ accentColor: '#002977' }}
                  />
                  <div className="incentive-image">
                    <img src="/kiosk_promotions.png" alt="Kiosk Promotions" />
                  </div>
                </label>
              </div>
            </section>

            {selectedIncentive && (
              <>
                {/* Display Options */}
                <div className="display-options-panel responsive-panel">
                  <div className="scrollable-content">
                    <h2>
                      {isUploadTargetedList && targetedListStep !== 'target'
                        ? 'Target market'
                        : 'Trigger settings'}
                    </h2>

                    {selectedIncentive === 'Kiosk' && (
                      <div className="field-block">
                        <label
                          className="field-label"
                          style={{ marginRight: '23px' }}
                        >
                          Promotion name
                        </label>
                        <input
                          type="text"
                          value={promotionName}
                          onChange={(e) => setPromotionName(e.target.value)}
                          className="text-input-trigger"
                        />
                      </div>
                    )}

                    <div
                      className="form-group inline-form-group"
                      style={{ marginBottom: '10px' }}
                    >
                      <label>
                        <strong>Audience</strong>
                      </label>

                      {isUploadTargetedList && targetedListStep === 'target' ? (
                        <div className="targeted-list-member-count">
                          {targetedListRows.length.toLocaleString()} members
                          targeted
                        </div>
                      ) : (
                        <>
                          <div
                            className="select-wrapper"
                            style={{
                              position: 'relative',
                              display: 'inline-block',
                              width: '100%',
                              zIndex: showAudienceDropdown ? 10 : 1,
                            }}
                            ref={audienceWrapperRef}
                          >
                            <div
                              className="multiselect-display"
                              onClick={toggleAudienceDropdown}
                              style={{
                                cursor: 'pointer',
                                lineHeight: '15px',
                                padding: '0 10px',
                                fontSize: '13px',
                                color: isEveryone
                                  ? '#999'
                                  : isUploadTargetedList
                                    ? '#5396d1'
                                    : '#666',
                              }}
                            >
                              {isEveryone
                                ? 'All Selected'
                                : isUploadTargetedList
                                  ? 'Upload targeted list'
                                  : selectedAudiences.length > 0
                                    ? selectedAudiences.length > 2
                                      ? `${selectedAudiences.length} selected`
                                      : audienceOptions
                                          .filter((o) =>
                                            selectedAudiences.includes(o.value)
                                          )
                                          .map((o) => o.label)
                                          .join(', ')
                                    : 'Select from list'}
                            </div>

                            {showAudienceDropdown && (
                              <div
                                className="multiselect-options"
                                style={{
                                  position: 'absolute',
                                  top: '100%',
                                  left: 0,
                                  right: 0,
                                  background: 'white',
                                  maxHeight: '200px',
                                  overflowY: 'auto',
                                  border: '1px solid #ccc',
                                  borderRadius: '4px',
                                  boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
                                  zIndex: 1000,
                                  display: showAudienceDropdown
                                    ? 'block'
                                    : 'none',
                                }}
                              >
                                <div
                                  key={UPLOAD_TARGETED_LIST}
                                  className={`day-item targeted-list-audience-option ${
                                    isUploadTargetedList ? 'selected' : ''
                                  }`}
                                  onClick={() =>
                                    handleAudienceChange(UPLOAD_TARGETED_LIST)
                                  }
                                >
                                  <span>Upload targeted list</span>
                                </div>
                                {audienceOptions.map((option) => (
                                  <div
                                    key={option.value}
                                    className="day-item"
                                    style={{
                                      padding: '5px 10px',
                                    }}
                                  >
                                    <input
                                      type="checkbox"
                                      id={`aud-${option.value}`}
                                      checked={
                                        !isUploadTargetedList &&
                                        selectedAudiences.includes(option.value)
                                      }
                                      onChange={() =>
                                        handleAudienceChange(option.value)
                                      }
                                    />
                                    <label
                                      htmlFor={`aud-${option.value}`}
                                      style={{ marginLeft: '6px' }}
                                    >
                                      {option.label}
                                    </label>
                                  </div>
                                ))}
                              </div>
                            )}
                          </div>
                          <div
                            className="day-item"
                            style={{ marginTop: '10px', marginLeft: '5px' }}
                          >
                            <input
                              type="checkbox"
                              id="aud-everyone"
                              checked={isEveryone}
                              onChange={handleEveryoneChange}
                            />
                            <label htmlFor="aud-everyone">Everyone</label>
                          </div>
                        </>
                      )}
                    </div>

                    {isUploadTargetedList ? (
                      <div
                        className={`targeted-list-market ${
                          targetedListStep === 'target' ? 'confirmed' : ''
                        }`}
                      >
                        {targetedListStep !== 'target' && (
                          <div className="targeted-list-steps">
                            <div className="targeted-list-step active">
                              <span>1</span>
                              <span>Upload</span>
                            </div>

                            <div className="targeted-list-step-line" />

                            <div
                              className={`targeted-list-step ${
                                targetedListStep === 'review' ? 'active' : ''
                              }`}
                            >
                              <span>2</span>
                              <span>Review</span>
                            </div>
                          </div>
                        )}

                        {targetedListStep === 'upload' ? (
                          <>
                            <div
                              className="targeted-list-upload-box"
                              onClick={() =>
                                targetedListInputRef.current?.click()
                              }
                              onDragOver={(e) => e.preventDefault()}
                              onDrop={(e) => {
                                e.preventDefault();

                                const file = e.dataTransfer.files?.[0];
                                if (!file) return;

                                const allowedExtensions = [
                                  '.xlsx',
                                  '.xls',
                                  '.csv',
                                ];
                                const fileName = file.name.toLowerCase();

                                if (
                                  !allowedExtensions.some((ext) =>
                                    fileName.endsWith(ext)
                                  )
                                ) {
                                  toast.error(
                                    'Please upload an Excel or CSV file'
                                  );
                                  return;
                                }

                                const reader = new FileReader();

                                reader.onload = (event) => {
                                  try {
                                    const data = new Uint8Array(
                                      event.target.result
                                    );

                                    const workbook = XLSX.read(data, {
                                      type: 'array',
                                    });

                                    const worksheet =
                                      workbook.Sheets[workbook.SheetNames[0]];

                                    const rows = XLSX.utils.sheet_to_json(
                                      worksheet,
                                      { defval: '' }
                                    );

                                    if (!rows.length) {
                                      toast.error(
                                        'The uploaded file contains no data'
                                      );
                                      return;
                                    }

                                    setTargetedListFile(file);
                                    setTargetedListRows(rows);

                                    // Go directly to Review after drag & drop
                                    setTargetedListStep('review');
                                  } catch (error) {
                                    console.error(error);
                                    toast.error(
                                      'Unable to read the uploaded file'
                                    );
                                  }
                                };

                                reader.readAsArrayBuffer(file);
                              }}
                            >
                              <h3>Upload Your File</h3>

                              <p>
                                Upload an Excel or CSV file to import your data.
                              </p>

                              <img
                                src="/page.png"
                                alt="Upload file"
                                className="targeted-list-file-icon"
                              />

                              <div className="targeted-list-browse-text">
                                Drag a file here or <span>browse</span> for a
                                file to upload.
                              </div>

                              <input
                                ref={targetedListInputRef}
                                type="file"
                                accept=".xlsx,.xls,.csv"
                                style={{ display: 'none' }}
                                onChange={(e) => {
                                  const file = e.target.files?.[0];

                                  if (!file) return;

                                  const reader = new FileReader();

                                  reader.onload = (event) => {
                                    try {
                                      const data = new Uint8Array(
                                        event.target.result
                                      );

                                      const workbook = XLSX.read(data, {
                                        type: 'array',
                                      });

                                      const worksheet =
                                        workbook.Sheets[workbook.SheetNames[0]];

                                      const rows = XLSX.utils.sheet_to_json(
                                        worksheet,
                                        { defval: '' }
                                      );

                                      if (!rows.length) {
                                        toast.error(
                                          'The uploaded file contains no data'
                                        );
                                        return;
                                      }

                                      setTargetedListFile(file);
                                      setTargetedListRows(rows);
                                      setTargetedListStep('review');
                                    } catch (error) {
                                      console.error(error);
                                      toast.error(
                                        'Unable to read the uploaded file'
                                      );
                                    }
                                  };

                                  reader.readAsArrayBuffer(file);
                                }}
                              />
                            </div>

                            {/* <button
                              type="button"
                              className="targeted-list-template-btn"
                              onClick={() => {
                                const worksheet = XLSX.utils.json_to_sheet([
                                  {
                                    'Member ID': '',
                                  },
                                ]);

                                const workbook = XLSX.utils.book_new();

                                XLSX.utils.book_append_sheet(
                                  workbook,
                                  worksheet,
                                  'Targeted List'
                                );

                                XLSX.writeFile(
                                  workbook,
                                  'targeted-list-template.xlsx'
                                );
                              }}
                            >
                              ↓ &nbsp;Download template
                            </button> */}

                            <div className="targeted-list-actions">
                              <button
                                type="button"
                                className="targeted-list-cancel-btn"
                                onClick={() => {
                                  setIsUploadTargetedList(false);
                                  setTargetedListFile(null);
                                  setTargetedListRows([]);
                                  setTargetedListStep('upload');
                                }}
                              >
                                CANCEL
                              </button>

                              {/* <button
                                type="button"
                                className="targeted-list-upload-btn"
                                // disabled={!targetedListFile}
                                onClick={() => {
                                  if (!targetedListFile) {
                                    toast.error('Please select a file');
                                    return;
                                  }

                                  setTargetedListStep('review');
                                }}
                              >
                                UPLOAD
                              </button> */}
                            </div>
                          </>
                        ) : targetedListStep === 'review' ? (
                          <>
                            <div className="targeted-list-review">
                              <h3>Review Target File</h3>

                              <p className="targeted-list-review-subtitle">
                                Review your uploaded file before using it for
                                targeting.
                              </p>

                              <div className="targeted-list-success">
                                <span className="targeted-list-success-icon">
                                  ✓
                                </span>
                                <span>File uploaded successfully</span>
                              </div>

                              <div className="targeted-list-file-row">
                                <div className="targeted-list-file-info">
                                  <img
                                    src="/page.png"
                                    alt="File"
                                    className="targeted-list-review-file-icon"
                                  />

                                  <span>{targetedListFile?.name}</span>
                                </div>

                                <button
                                  type="button"
                                  className="targeted-list-view-file-btn"
                                  onClick={() => {
                                    if (targetedListFile) {
                                      const url =
                                        URL.createObjectURL(targetedListFile);
                                      window.open(url, '_blank');
                                    }
                                  }}
                                >
                                  View File
                                </button>
                              </div>

                              <div className="targeted-list-record-count">
                                {targetedListRows.length.toLocaleString()}
                              </div>

                              <p className="targeted-list-ready-text">
                                Your file is ready to use for targeting.
                              </p>
                            </div>

                            <div className="targeted-list-actions targeted-list-review-actions">
                              <button
                                type="button"
                                className="targeted-list-cancel-btn"
                                onClick={() => {
                                  setTargetedListFile(null);
                                  setTargetedListRows([]);
                                  setTargetedListStep('upload');

                                  if (targetedListInputRef.current) {
                                    targetedListInputRef.current.value = '';
                                  }
                                }}
                              >
                                UPLOAD A DIFFERENT FILE
                              </button>

                              <button
                                type="button"
                                className="targeted-list-upload-btn"
                                onClick={() => {
                                  setTargetedListStep('target');
                                }}
                              >
                                USE THIS FILE
                              </button>
                            </div>
                          </>
                        ) : (
                          <>
                            <div className="targeted-list-final">
                              <div className="targeted-list-final-card">
                                <h3>Target File</h3>
                                <div className="targeted-list-final-file-row">
                                  <div className="targeted-list-file-info">
                                    <img
                                      src="/page.png"
                                      alt="File"
                                      className="targeted-list-review-file-icon"
                                    />

                                    <span>{targetedListFile?.name}</span>
                                  </div>

                                  <button
                                    type="button"
                                    className="targeted-list-view-file-btn"
                                    onClick={() => {
                                      if (targetedListFile) {
                                        const url =
                                          URL.createObjectURL(targetedListFile);
                                        window.open(url, '_blank');
                                      }
                                    }}
                                  >
                                    View File
                                  </button>
                                </div>

                                <div className="targeted-list-record-count">
                                  {targetedListRows.length.toLocaleString()}
                                </div>
                              </div>
                            </div>

                            {/* Points to Award */}
                            <div
                              className="flex-row targeted-list-final-points"
                              style={{ marginBottom: '30px' }}
                            >
                              <label
                                className="field-label"
                                style={{
                                  textWrap: 'nowrap',
                                  marginRight: '50px',
                                }}
                              >
                                Points to Award
                              </label>

                              <input
                                type="text"
                                value={tempBenefits}
                                onChange={(e) =>
                                  setTempBenefits(e.target.value)
                                }
                                className="text-input-trigger"
                                placeholder="20,000"
                                style={{ width: '80px' }}
                              />

                              <div style={{ fontSize: '12px' }}>
                                Points&nbsp;&nbsp;
                                <strong>$ Value = ${pointsDollarValue}</strong>
                              </div>
                            </div>

                            {/* Budget */}
                            <div>
                              <label className="day-item">
                                <input
                                  type="checkbox"
                                  checked={unlimitedBudget}
                                  onChange={(e) =>
                                    setUnlimitedBudget(e.target.checked)
                                  }
                                />
                                <span>No budget</span>
                              </label>
                            </div>

                            <div
                              className="flex-row"
                              style={{
                                marginBottom: '30px',
                                visibility: unlimitedBudget
                                  ? 'hidden'
                                  : 'visible',
                              }}
                            >
                              <label
                                className="field-label"
                                style={{
                                  textWrap: 'nowrap',
                                  marginRight: '20px',
                                }}
                              >
                                Set budget
                              </label>

                              <div className="flex-row">
                                <input
                                  type="text"
                                  inputMode="numeric"
                                  value={budget}
                                  disabled={unlimitedBudget}
                                  onChange={(e) => {
                                    const value = e.target.value;

                                    if (/^\d*$/.test(value)) {
                                      setBudget(value);
                                    }
                                  }}
                                  className="text-input-trigger"
                                  style={{
                                    width: '80px',
                                    marginRight: '10px',
                                    opacity: unlimitedBudget ? 0.5 : 1,
                                  }}
                                />

                                <div
                                  style={{
                                    fontSize: '12px',
                                    marginLeft: '5px',
                                    whiteSpace: 'nowrap',
                                  }}
                                >
                                  <strong>
                                    $ Value = ${budgetDollarValue}
                                  </strong>
                                </div>
                              </div>
                            </div>

                            {/* Start & End incentive */}
                            <div className="flex-row">
                              <label
                                className="field-label"
                                style={{
                                  textWrap: 'nowrap',
                                  marginRight: '90px',
                                }}
                              >
                                Start & End incentive
                              </label>

                              <div className="schedule-row-si">
                                <div className="date-field">
                                  <label className="date-label">
                                    START DATE
                                  </label>

                                  <input
                                    type="date"
                                    value={scheduleStart}
                                    onChange={(e) =>
                                      setScheduleStart(e.target.value)
                                    }
                                    className="date-input"
                                  />
                                </div>

                                <div className="date-field">
                                  <label className="date-label">END DATE</label>

                                  <input
                                    type="date"
                                    value={scheduleEnd}
                                    onChange={(e) =>
                                      setScheduleEnd(e.target.value)
                                    }
                                    className="date-input"
                                  />
                                </div>
                              </div>
                            </div>
                          </>
                        )}
                      </div>
                    ) : (
                      <>
                        {/* Trigger by */}
                        <div
                          className="form-group inline-form-group"
                          style={{ marginBottom: '20px' }}
                        >
                          <label>
                            <strong>Trigger by</strong>
                          </label>
                          <div
                            className="select-wrapper"
                            style={{
                              position: 'relative',
                              display: 'inline-block',
                              width: '100%',
                            }}
                            ref={triggerWrapperRef}
                          >
                            <div
                              className="multiselect-display"
                              onClick={toggleTriggerDropdown}
                              style={{
                                cursor: 'pointer',
                                lineHeight: '15px',
                                padding: '0 10px',
                                fontSize: '13px',
                                color: '#666',
                              }}
                            >
                              {selectedTrigger
                                ? triggerOptions.find(
                                    (o) => o.value === selectedTrigger
                                  )?.label
                                : 'Select from list'}
                            </div>

                            {showTriggerDropdown && (
                              <div
                                className="multiselect-options"
                                style={{
                                  position: 'absolute',
                                  top: '100%',
                                  left: 0,
                                  right: 0,
                                  background: 'white',
                                  maxHeight: '200px',
                                  overflowY: 'auto',
                                  border: '1px solid #ccc',
                                  borderRadius: '4px',
                                  // boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
                                  zIndex: 1000,
                                  display: showTriggerDropdown
                                    ? 'block'
                                    : 'none',
                                }}
                              >
                                {triggerOptions.map((option) => (
                                  <div
                                    key={option.value}
                                    className="day-item"
                                    style={{
                                      padding: '8px 10px',
                                      cursor: 'pointer',
                                    }}
                                    onClick={() => {
                                      handleTriggerChange(option.value);
                                      setShowTriggerDropdown(false);
                                    }}
                                  >
                                    {/* <input
                                  type="radio"
                                  name="triggerType"
                                  checked={selectedTrigger === option.value}
                                  onChange={() =>
                                    handleTriggerChange(option.value)
                                  }
                                /> */}
                                    <label
                                      htmlFor={`aud-${option.value}`}
                                      style={{ marginLeft: '6px' }}
                                    >
                                      {option.label}
                                    </label>
                                  </div>
                                ))}
                              </div>
                            )}
                          </div>
                        </div>

                        {/* Trigger value */}
                        <div className="field-block">
                          <label
                            className="field-label"
                            style={{ marginRight: '45px' }}
                          >
                            Trigger value
                          </label>
                          <input
                            type="text"
                            value={triggerValue}
                            onChange={(e) => setTriggerValue(e.target.value)}
                            className="text-input-trigger"
                          />
                        </div>

                        {/* Trigger time period */}
                        <div
                          className="field-block"
                          style={{ marginBottom: '40px' }}
                        >
                          <label className="field-label">
                            Trigger time period
                          </label>
                          {/* first row: daily + weekly */}
                          <div className="flex-row" style={{ gap: '10px' }}>
                            {[
                              'daily',
                              'last 7 days',
                              'last 14 days',
                              'last 30 days',
                            ].map((tp) => (
                              <label
                                key={tp}
                                className="radio-label"
                                style={{ gap: '0px' }}
                              >
                                <input
                                  type="radio"
                                  name="timePeriod"
                                  value={getTTPValue(tp)}
                                  checked={timePeriod === tp}
                                  onChange={() => setTimePeriod(tp)}
                                  style={{ accentColor: '#002977' }}
                                />
                                <span>
                                  {tp.charAt(0).toUpperCase() + tp.slice(1)}
                                </span>
                              </label>
                            ))}
                          </div>
                        </div>

                        {/* Points bonus value */}
                        <div
                          className="flex-row"
                          style={{ marginBottom: '40px' }}
                        >
                          <label
                            className="field-label"
                            style={{ textWrap: 'nowrap', marginRight: '50px' }}
                          >
                            Points to Award
                          </label>

                          <input
                            type="text"
                            value={tempBenefits}
                            onChange={(e) => setTempBenefits(e.target.value)}
                            className="text-input-trigger"
                            placeholder="20,000"
                            style={{ width: '80px' }}
                          />

                          <div style={{ fontSize: '12px' }}>
                            Points&nbsp;&nbsp;
                            <strong>$ Value = ${pointsDollarValue}</strong>
                          </div>
                        </div>

                        {/* Budget */}
                        <div>
                          <label className="day-item">
                            <input
                              type="checkbox"
                              checked={unlimitedBudget}
                              onChange={(e) =>
                                setUnlimitedBudget(e.target.checked)
                              }
                            />
                            <span>No budget</span>
                          </label>
                        </div>

                        <div
                          className="flex-row"
                          style={{
                            marginBottom: '30px',
                            visibility: unlimitedBudget ? 'hidden' : 'visible',
                          }}
                        >
                          <label
                            className="field-label"
                            style={{ textWrap: 'nowrap', marginRight: '20px' }}
                          >
                            Set budget
                          </label>

                          <div className="flex-row">
                            <input
                              type="text"
                              inputMode="numeric"
                              value={budget}
                              disabled={unlimitedBudget}
                              onChange={(e) => {
                                const value = e.target.value;
                                if (/^\d*$/.test(value)) {
                                  setBudget(value);
                                }
                              }}
                              className="text-input-trigger"
                              style={{
                                width: '80px',
                                marginRight: '10px',
                                opacity: unlimitedBudget ? 0.5 : 1,
                              }}
                            />
                            <div
                              style={{
                                fontSize: '12px',
                                marginLeft: '5px',
                                whiteSpace: 'nowrap',
                              }}
                            >
                              <strong>$ Value = ${budgetDollarValue}</strong>
                            </div>
                          </div>
                        </div>

                        {/* Start & End incentive */}
                        <div className="flex-row">
                          <label
                            className="field-label"
                            style={{ textWrap: 'nowrap', marginRight: '90px' }}
                          >
                            Start & End incentive
                          </label>

                          <div className="schedule-row-si">
                            <div className="date-field">
                              <label className="date-label">START DATE</label>
                              <input
                                type="date"
                                value={scheduleStart}
                                onChange={(e) =>
                                  setScheduleStart(e.target.value)
                                }
                                className="date-input"
                              />
                            </div>

                            <div className="date-field">
                              <label className="date-label">END DATE</label>
                              <input
                                type="date"
                                value={scheduleEnd}
                                onChange={(e) => setScheduleEnd(e.target.value)}
                                className="date-input"
                              />
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </>
            )}
          </div>

          {selectedIncentive && (
            <>
              {/* Live Smart Incentives Section */}
              <div className="live-smart-incentives">
                <h2>Delivery Method</h2>
                <div className="incentive-options">
                  {selectedIncentive === 'Point Bonus' ? (
                    <>
                      <label className="incentive-option">
                        <input
                          type="radio"
                          name="deliveryMethod"
                          value="Scratch & Win"
                          checked={deliveryMethod === 'Scratch & Win'}
                          onChange={(e) => setDeliveryMethod(e.target.value)}
                          className="incentive-radio"
                          style={{ accentColor: '#002977' }}
                        />
                        <div>
                          <img
                            src="/scratch_and_win.png"
                            alt="Scratch and Win"
                            style={{ width: '80%' }}
                          />
                        </div>
                      </label>
                    </>
                  ) : (
                    <>
                      <p style={{ marginTop: '20px' }}>
                        This promotion will be sent to your Wymac Kiosk
                        <br />
                        <br />
                        Please select the type of promotion at the kiosk
                      </p>
                    </>
                  )}
                </div>
              </div>
            </>
          )}

          {/* ========== CONTROL BUTTONS ========== */}
          <button
            className="publish-displays-btn icon-button"
            onClick={() => handlePublishIncentive()}
            disabled={publishing}
          >
            <FaCheck className="button-icon" />
            {publishing ? 'PUBLISHING...' : 'PUBLISH'}{' '}
          </button>
        </div>
      ) : (
        <div className="members-table-container-si" style={{ marginTop: '0%' }}>
          {loading ? (
            <div className="loading">Loading...</div>
          ) : (
            <>
              <table
                className="members-table-si"
                style={{ marginTop: '160px' }}
              >
                <thead>
                  <tr>
                    <th>Date Created</th>
                    <th>Created By</th>
                    <th>Promo Name</th>
                    <th>Promo ID</th>
                    <th>Offer Type</th>
                    <th>Start Date</th>
                    <th>End Date</th>
                    <th>Trigger Type</th>
                    <th>Trigger Value</th>
                    <th>Time Period</th>
                    <th>Avg Prize</th>
                    <th>Incentives Issued</th>
                    <th>Incentives Redeemed</th>
                    <th>Budget</th>
                    <th>Value of Incentives Issued</th>
                    <th>Budget Remaining</th>
                    {activeTab === 'expiredIncentives' && <th>Date Expired</th>}
                  </tr>
                </thead>
                <tbody>
                  {(activeTab === 'activeCampaigns' ||
                    activeTab === 'expiredIncentives') && (
                    <>
                      {tableData.length > 0 ? (
                        tableData.map((data, index) => (
                          <tr key={index}>
                            <td>
                              {data.createdAt
                                .substring(0, 10)
                                .split('-')
                                .reverse()
                                .join('-') || '-'}
                            </td>
                            <td>{data.createdByName || '-'}</td>
                            <td>{data.promotionName || '-'}</td>
                            <td>{data.promoId || '-'}</td>
                            <td>{data.offerType || '-'}</td>
                            <td>{formatDateWithOffset(data.startDate)}</td>
                            <td>{formatDateWithOffset(data.endDate)}</td>
                            <td>
                              {formatTriggerType(data.triggerType) || '-'}
                            </td>
                            <td>{data.triggerValue || '-'}</td>
                            <td>{formatTimePeriod(data.timePeriod) || '-'}</td>
                            <td>{data.incentiveValue || '-'}</td>
                            <td>
                              {data.audienceMode === 'csv' ? (
                                <span
                                  onClick={() =>
                                    handleExportApplicableUsers(data._id)
                                  }
                                  style={{
                                    color: '#002977',
                                    textDecoration: 'underline',
                                    cursor: 'pointer',
                                    fontWeight: 500,
                                  }}
                                >
                                  {processingCsvIncentiveId === data._id ? (
                                    <LuLoader />
                                  ) : (
                                    data.csvProcessedUsers
                                  )}
                                </span>
                              ) : data.applicableUserCount ? (
                                <span
                                  onClick={() =>
                                    handleExportApplicableUsers(data._id)
                                  }
                                  style={{
                                    color: '#002977',
                                    textDecoration: 'underline',
                                    cursor: 'pointer',
                                    fontWeight: 500,
                                  }}
                                >
                                  {data.applicableUserCount}
                                </span>
                              ) : (
                                '-'
                              )}
                            </td>
                            <td>
                              {data.totalIssuedCount ? (
                                <span
                                  onClick={() =>
                                    handleExportRedeemedUsers(data._id)
                                  }
                                  style={{
                                    color: '#002977',
                                    textDecoration: 'underline',
                                    cursor: 'pointer',
                                    fontWeight: 500,
                                  }}
                                >
                                  {data.totalIssuedCount}
                                </span>
                              ) : (
                                '-'
                              )}
                            </td>
                            <td>{data.budget || '-'}</td>
                            <td>{data.totalIssuedValue || '-'}</td>
                            <td>{data.budgetRemaining || '-'}</td>
                            {activeTab === 'activeCampaigns' && (
                              <td>
                                <button
                                  className="action-btn-endsi approve"
                                  onClick={() =>
                                    handleDeactivateIncentive(data._id)
                                  }
                                  style={{ borderRadius: '50px' }}
                                >
                                  END INCENTIVE
                                </button>
                              </td>
                            )}
                            {activeTab === 'expiredIncentives' && (
                              <td>
                                {data.status === 'inactive'
                                  ? data.inactiveDateBrisbane
                                      .substring(0, 10)
                                      .split('-')
                                      .reverse()
                                      .join('-')
                                  : formatDateWithOffset(data.endDate)}
                              </td>
                            )}
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="8" className="no-data">
                            No incentives found
                          </td>
                        </tr>
                      )}
                    </>
                  )}
                </tbody>
              </table>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  marginTop: '20px',
                  paddingRight: '20px',
                  paddingLeft: '20px',
                }}
              >
                <button
                  onClick={onPrev}
                  disabled={currentPage === 1}
                  style={{
                    padding: '8px 16px',
                    borderRadius: '4px',
                    border: '1px solid #ccc',
                    backgroundColor: currentPage === 1 ? '#e0e0e0' : '#002977',
                    color: currentPage === 1 ? '#999' : 'white',
                    cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
                    fontWeight: '500',
                  }}
                >
                  ← Previous
                </button>
                <span style={{ fontWeight: '500', color: '#002977' }}>
                  Page {currentPage} of {currentTotalPages}
                </span>
                <button
                  onClick={onNext}
                  disabled={currentPage >= currentTotalPages}
                  style={{
                    padding: '8px 16px',
                    borderRadius: '4px',
                    border: '1px solid #ccc',
                    backgroundColor:
                      currentPage >= currentTotalPages ? '#e0e0e0' : '#002977',
                    color: currentPage >= currentTotalPages ? '#999' : 'white',
                    cursor:
                      currentPage >= currentTotalPages
                        ? 'not-allowed'
                        : 'pointer',
                    fontWeight: '500',
                  }}
                >
                  Next →
                </button>
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default SmartIncentives;
